import * as React from 'react';
import { EntityCard } from '@ui/components';

import './CollectionCard.less';
import { Icon } from 'antd';
import * as moment from 'moment';
import collectionPng from '@ui/assets/collection.png';
import { getApiUrl } from '../../../../utils/config';

interface Props {
  collection: any;
  status: boolean;
  onChangeStatus: (collectionId: string, status: boolean) => void;
  historyCollection: any;
  setHasEdit: () => void;
  hasEditDefault: boolean;
}

class CollectionCard extends React.Component<Props> {
  state = {
    hasEdit: false,
  };

  static getDerivedStateFromProps({
    hasEditDefault,
  }: {
    hasEditDefault: boolean;
  }) {
    return {
      hasEdit: hasEditDefault,
    };
  }

  handleChangeStatus = (collectionId: string, status: boolean) => {
    const { onChangeStatus, setHasEdit } = this.props;

    const { hasEdit } = this.state;

    if (!hasEdit) {
      setHasEdit();
    }

    this.setState({ hasEdit: true });
    onChangeStatus(collectionId, status);
  };

  render() {
    const { collection, status, historyCollection } = this.props;
    const { hasEdit } = this.state;

    return (
      <EntityCard>
        <div className="store-collection-card">
          <div className="store-collection-card-panel">
            <div className="store-collection-card-panel__photo">
              {collection.photo ? (
                <img
                  src={`${getApiUrl()}/collection/${collection.id}/get-photo`}
                  width="100px"
                  height="100%"
                  alt=""
                />
              ) : (
                  <img src={collectionPng} width="100px" height="100%" alt="" />
                )}
            </div>
            <div className="store-collection-card-panel__info">
              <span>{collection.name}</span>
              <span
                style={{
                  color: historyCollection.status ? 'green' : 'red',
                }}
              >
                статус
              </span>
            </div>
            <div className="store-collection-card-panel__last">
              {historyCollection.status ? (
                <Icon
                  className="store-collection-card__icon"
                  type="check-square"
                  style={{
                    // @ts-ignore
                    color: 'green',
                    fontWeight: 'normal',
                  }}
                />
              ) : (
                  <Icon
                    className="store-collection-card__icon"
                    type="close-square"
                    style={{
                      color: 'red',
                      fontWeight: 'normal',
                      paddingLeft: '5px',
                    }}
                  />
                )}
              <div className="store-collection-card-panel__last__updated">
                <span>
                  {moment(historyCollection.updated).format('DD.MM.YYYY')}
                </span>
              </div>
            </div>
            <div className="store-collection-card-panel__actions">
              <Icon
                className="store-collection-card__icon"
                type="check-square"
                style={{
                  // @ts-ignore
                  color: hasEdit ? (status ? 'green' : '#a7a8aa') : '#a7a8aa',
                  fontWeight: 'normal',
                }}
                onClick={() => this.handleChangeStatus(collection.id, true)}
              />
              <Icon
                className="store-collection-card__icon"
                type="close-square"
                style={{
                  color: hasEdit ? (!status ? 'red' : '#a7a8aa') : '#a7a8aa',
                  fontWeight: 'normal',
                  paddingLeft: '5px',
                }}
                onClick={() => this.handleChangeStatus(collection.id, false)}
              />
            </div>
          </div>
        </div>
      </EntityCard>
    );
  }
}

export default CollectionCard;



// WEBPACK FOOTER //
// ./src/scenes/Store/components/CollectionCard/CollectionCard.tsx